import { AppBar, Toolbar } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../assets/simboloVitaResize.png';

const PrivacySection = ({ title, children }) => (
  <div className='flex flex-col gap-6 py-12 first:pt-0'>
    <h2 className='text-3xl md:text-4xl font-bold bg-gradient-to-r from-[#27E2E7] to-[#53BCC3] text-transparent bg-clip-text'>
      {title}
    </h2>
    <div className='text-gray-600 space-y-4 text-lg leading-relaxed'>
      {children}
    </div>
  </div>
);

const PrivacyPage = () => {
  return (
    <div className='min-h-screen bg-gray-50'>
      <nav>
        <AppBar position='fixed' elevation={0} sx={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(8px)' }}>
          <Toolbar className='flex justify-between gap-2 h-20 px-4 md:px-8'>
            <RouterLink to='/' className='flex items-center'>
              <img 
                src={logo} 
                alt='vita-logo' 
                className='w-16 h-auto transform hover:scale-105 transition-transform duration-300' 
              />
            </RouterLink>
            <div className='flex gap-6'>
              <RouterLink
                to='/'
                className='text-gray-800 font-medium hover:text-[#27E2E7] transition-colors duration-300'
              >
                Voltar para Home
              </RouterLink>
              <RouterLink
                to='/planos'
                className='text-gray-800 font-medium hover:text-[#27E2E7] transition-colors duration-300'
              >
                Planos
              </RouterLink>
            </div>
          </Toolbar>
        </AppBar>
      </nav>

      <main className='container mx-auto px-4 md:px-6 lg:px-8 pt-32 pb-16 max-w-4xl'>
        <div className='bg-white rounded-2xl shadow-lg p-8 md:p-12'>
          <h1 className='text-4xl md:text-5xl font-bold mb-12 bg-gradient-to-r from-[#27E2E7] via-[#53BCC3] to-blue-400 text-transparent bg-clip-text'>
            Política de Privacidade
          </h1>

          <PrivacySection title="Mensagens">
            <p>
              As mensagens que são enviadas contendo suas informações (nome, email e telefone) 
              são recebidas no nosso email <span className='font-semibold text-[#27E2E7]'>contato@pranaconsultoria.com</span> e 
              servem para fazermos contato e atender você cliente da melhor maneira possível.
            </p>
            <p>
              Você pode solicitar um arquivo exportado dos dados pessoais que mantemos sobre você, 
              incluindo todos os dados que você nos forneceu. Você também pode solicitar que 
              apaguemos todos os dados pessoais que mantemos sobre você. Isso não inclui nenhum 
              dado que somos obrigados a manter para fins administrativos, legais ou de segurança.
            </p>
          </PrivacySection>

          <PrivacySection title="Cookies">
            <div className='space-y-4'>
              <p>
                Se você deixar um comentário em nosso site, poderá optar por salvar seu nome, 
                endereço de e-mail e site em cookies. Estes são para sua conveniência, para que 
                você não precise preencher seus dados novamente quando deixar outro comentário. 
                Esses cookies duram um ano.
              </p>
              <p>
                Se você visitar nossa página de login, definiremos um cookie temporário para 
                determinar se o seu navegador aceita cookies. Este cookie não contém dados 
                pessoais e é descartado quando você fecha o navegador.
              </p>
              <p>
                Ao fazer login, também configuraremos vários cookies para salvar suas informações 
                de login e suas opções de exibição na tela. Os cookies de login duram dois dias e 
                os cookies de opções de tela duram um ano.
              </p>
              <p>
                Se você selecionar "Lembrar de mim", seu login persistirá por duas semanas. Se 
                você sair da sua conta, os cookies de login serão removidos.
              </p>
              <p>
                Se você editar ou publicar um artigo, um cookie adicional será salvo no seu 
                navegador. Este cookie não inclui dados pessoais e simplesmente indica o ID da 
                postagem do artigo que você acabou de editar. Expira após 1 dia.
              </p>
            </div>
          </PrivacySection>

          <PrivacySection title="Conteúdo incorporado de outros sites">
            <p>
              Os artigos deste site podem incluir conteúdo incorporado (por exemplo, vídeos, 
              imagens, artigos etc.). O conteúdo incorporado de outros sites se comporta 
              exatamente da mesma maneira como se o visitante tivesse visitado o outro site.
            </p>
            <p>
              Esses sites podem coletar dados sobre você, usar cookies, incorporar rastreamento 
              adicional de terceiros e monitorar sua interação com esse conteúdo incorporado, 
              incluindo o rastreamento de sua interação com o conteúdo incorporado, se você 
              tiver uma conta e estiver logado nesse site.
            </p>
          </PrivacySection>

          <PrivacySection title="Por quanto tempo mantemos os dados">
            <p>
              Mantemos os dados por 5 anos, todos mapeados de acordo com a lei 13.709/2018 que 
              regula a atividade de tratamento de dados no Brasil.
            </p>
          </PrivacySection>

          <PrivacySection title="Seus direitos como titular de dados">
            <div className='space-y-4'>
              <p>Para exercer seus direitos, entre em contato através do email: <span className='font-semibold text-[#27E2E7]'>contato@vita.app.br</span></p>
              <p>DPO: Kássio da Silva Policarpo</p>
              <p className='font-semibold'>Direitos do titular (Lei 13.709/2018):</p>
              <ul className='space-y-2 list-disc pl-6'>
                <li>Confirmação da existência de tratamento</li>
                <li>Acesso aos dados</li>
                <li>Correção dos dados incompletos, inexatos ou desatualizados</li>
                <li>Eliminação de dados desnecessários</li>
                <li>Portabilidade de dados</li>
                <li>Eliminação de dados pessoais tratados com consentimento</li>
                <li>Informações sobre o compartilhamento de dados</li>
                <li>Informação sobre fornecer consentimento</li>
                <li>Revogação do consentimento</li>
              </ul>
            </div>
          </PrivacySection>

          <div className='mt-16 pt-8 border-t border-gray-200'>
            <p className='text-gray-600'>
              O Vita App é um produto desenvolvido a partir das experiências da{' '}
              <a
                href='https://pranaconsultoria.com'
                target='_blank'
                rel='noopener noreferrer'
                className='font-semibold text-[#27E2E7] hover:text-[#1fa8ac] transition-colors duration-300'
              >
                Prana Vitalidade Empresarial
              </a>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
